<div class="legal-page">
  <div class="legal-container">

    <!-- Top Navigation Bar -->
    <div class="legal-nav-bar">
      <button type="button" class="back-btn" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back</span>
      </button>
      <div class="brand-logo-wrap">
        <img src="assets/logo-jjames.webp" alt="JJames Smart Parking" class="brand-logo">
      </div>
    </div>

    <!-- Header Section -->
    <div class="legal-header">
      <h1 class="main-title">Rechtliche Hinweise & Datenschutz</h1>
      <p class="subtitle">Datenschutzerklärung, Nutzungsbedingungen und Impressum der JJ Technology Holding GmbH</p>
      <div class="effective-date">
        <mat-icon class="date-icon">event</mat-icon>
        <span>Fassung 05.09.2019-211101306 · Zuletzt aktualisiert</span>
      </div>
    </div>

    <!-- Quick Navigation / Table of Contents -->
    <div class="table-of-contents">
      <span class="toc-title">Übersicht:</span>
      <div class="toc-links">
        <a class="toc-chip" (click)="scrollToSection('datenschutz')">1. Datenschutz</a>
        <a class="toc-chip" (click)="scrollToSection('datenspeicherung')">2. Automatische Datenspeicherung</a>
        <a class="toc-chip" (click)="scrollToSection('cookies')">3. Cookies</a>
        <a class="toc-chip" (click)="scrollToSection('persoenliche-daten')">4. Speicherung persönlicher Daten</a>
        <a class="toc-chip" (click)="scrollToSection('dsgvo-rechte')">5. Rechte laut DSGVO</a>
        <a class="toc-chip" (click)="scrollToSection('besucherverhalten')">6. Besucherverhalten</a>
        <a class="toc-chip" (click)="scrollToSection('tls-verschluesselung')">7. TLS-Verschlüsselung</a>
        <a class="toc-chip" (click)="scrollToSection('impressum')">8. Impressum & Anbieter</a>
      </div>
    </div>

    <!-- Main Content Card -->
    <div class="legal-card">

      <!-- Section: Datenschutz -->
      <section id="datenschutz" class="legal-section">
        <div class="section-badge">DSGVO / DSG</div>
        <h2>Datenschutzerklärung</h2>
        <p>
          Wir haben diese Datenschutzerklärung (Fassung 05.09.2019-211101306) verfasst, um Ihnen gemäß der Vorgaben der Datenschutz-Grundverordnung (EU) 2016/679 und dem
          <a href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=10001597&tid=211101306" target="_blank" rel="noopener nofollow" class="external-link">Datenschutzgesetz (DSG)</a>
          zu erklären, welche Informationen wir sammeln, wie wir Daten verwenden und welche Entscheidungsmöglichkeiten Sie als Besucher dieser Webseite haben.
        </p>
        <p>
          Leider liegt es in der Natur der Sache, dass diese Erklärungen sehr technisch klingen. Wir haben uns bei der Erstellung jedoch bemüht die wichtigsten Dinge so einfach und klar wie möglich zu beschreiben.
        </p>
      </section>

      <hr class="legal-divider">

      <!-- Section: Automatische Datenspeicherung -->
      <section id="datenspeicherung" class="legal-section">
        <h2>Automatische Datenspeicherung</h2>
        <p>
          Wenn Sie heutzutage Webseiten besuchen, werden gewisse Informationen automatisch erstellt und gespeichert, so auch auf dieser Webseite.
        </p>
        <p>
          Wenn Sie unsere Webseite so wie jetzt gerade besuchen, speichert unser Webserver (Computer auf dem diese Webseite gespeichert ist) automatisch Daten wie:
        </p>
        <ul class="legal-list">
          <li>die Adresse (URL) der aufgerufenen Webseite</li>
          <li>Browser und Browserversion</li>
          <li>das verwendete Betriebssystem</li>
          <li>die Adresse (URL) der zuvor besuchten Seite (Referrer URL)</li>
          <li>den Hostname und die IP-Adresse des Geräts von welchem aus zugegriffen wird</li>
          <li>Datum und Uhrzeit</li>
        </ul>
        <p>in Dateien (Webserver-Logfiles).</p>
        <div class="info-callout">
          <mat-icon class="callout-icon">info</mat-icon>
          <div>
            In der Regel werden Webserver-Logfiles zwei Wochen gespeichert und danach automatisch gelöscht. Wir geben diese Daten nicht weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem Verhalten eingesehen werden.
          </div>
        </div>
      </section>

      <hr class="legal-divider">

      <!-- Section: Cookies -->
      <section id="cookies" class="legal-section">
        <h2>Cookies</h2>
        <p>
          Unsere Website verwendet HTTP-Cookies um nutzerspezifische Daten zu speichern.
        </p>
        <p>
          Im Folgenden erklären wir, was Cookies sind und warum Sie genutzt werden, damit Sie die folgende Datenschutzerklärung besser verstehen.
        </p>

        <h3>Was genau sind Cookies?</h3>
        <p>
          Immer wenn Sie durch das Internet surfen, verwenden Sie einen Browser. Bekannte Browser sind beispielsweise Chrome, Safari, Firefox, Internet Explorer und Microsoft Edge. Die meisten Webseiten speichern kleine Text-Dateien in Ihrem Browser. Diese Dateien nennt man Cookies.
        </p>
        <p>
          Eines ist nicht von der Hand zu weisen: Cookies sind echt nützliche Helferlein. Fast alle Webseiten verwenden Cookies. Genauer gesagt sind es HTTP-Cookies, da es auch noch andere Cookies für andere Anwendungsbereiche gibt. HTTP-Cookies sind kleine Dateien, die von unserer Webseite auf Ihrem Computer abgelegt werden. Diese Cookie-Dateien werden automatisch im Cookie-Ordner, quasi dem „Hirn“ Ihres Browsers, untergebracht. Ein Cookie besteht aus einem Namen und einem Wert. Bei der Definition eines Cookies müssen zusätzlich ein oder mehrere Attribute angegeben werden.
        </p>

        <h3>Wie sieht es mit meinem Datenschutz aus?</h3>
        <p>
          Seit 2009 gibt es die sogenannten „Cookie-Richtlinien“. Darin ist festgehalten, dass das Speichern von Cookies eine Einwilligung des Website-Besuchers (also von Ihnen) verlangt. Innerhalb der EU-Länder gibt es allerdings noch sehr unterschiedliche Reaktionen auf diese Richtlinien. In Österreich erfolgte die Umsetzung dieser Richtlinie in § 96 Abs. 3 des Telekommunikationsgesetzes (TKG).
        </p>
        <p>
          Wenn Sie mehr über Cookies wissen möchten und vor technischen Dokumentationen nicht zurückscheuen, empfehlen wir
          <a href="https://tools.ietf.org/html/rfc6265" target="_blank" rel="nofollow noopener" class="external-link">https://tools.ietf.org/html/rfc6265</a>,
          dem Request for Comments der Internet Engineering Task Force (IETF) namens „HTTP State Management Mechanism“.
        </p>
      </section>

      <hr class="legal-divider">

      <!-- Section: Speicherung persönlicher Daten -->
      <section id="persoenliche-daten" class="legal-section">
        <h2>Speicherung persönlicher Daten</h2>
        <p>
          Persönliche Daten, die Sie uns auf dieser Website elektronisch übermitteln, wie zum Beispiel Name, E-Mail-Adresse, Adresse oder andere persönlichen Angaben im Rahmen der Übermittlung eines Formulars oder Registrierung, werden von uns gemeinsam mit dem Zeitpunkt und der IP-Adresse nur zum jeweils angegebenen Zweck verwendet, sicher verwahrt und nicht an Dritte weitergegeben, mit Ausnahme der für die Abwicklung von Rechnungserstellungen und Zahlungsvorgängen erforderlichen Daten wie Kontodaten, Kreditkartendaten, Adressdaten zu Zahlungsdiensten wie Stripe.
        </p>
        <p>
          Wir nutzen Ihre persönlichen Daten somit nur für die Kommunikation mit jenen Besuchern, die Kontakt ausdrücklich wünschen und für die Abwicklung der auf dieser Webseite angebotenen Dienstleistungen und Produkte. Wir geben Ihre persönlichen Daten ohne Zustimmung nicht weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem Verhalten eingesehen werden.
        </p>
        <div class="warning-callout">
          <mat-icon class="callout-icon">lock</mat-icon>
          <div>
            Wenn Sie uns persönliche Daten per E-Mail schicken – somit abseits dieser Webseite – können wir keine sichere Übertragung und den Schutz Ihrer Daten garantieren. Wir empfehlen Ihnen, vertrauliche Daten niemals unverschlüsselt per E-Mail zu übermitteln.
          </div>
        </div>
      </section>

      <hr class="legal-divider">

      <!-- Section: Rechte laut DSGVO -->
      <section id="dsgvo-rechte" class="legal-section">
        <h2>Rechte laut Datenschutzgrundverordnung</h2>
        <p>
          Ihnen stehen laut den Bestimmungen der DSGVO und des österreichischen
          <a href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=10001597&tid=211101306" target="_blank" rel="noopener nofollow" class="external-link">Datenschutzgesetzes (DSG)</a>
          grundsätzlich die folgenden Rechte zu:
        </p>
        <ul class="legal-list checkmarks">
          <li><strong>Recht auf Berichtigung</strong> (Artikel 16 DSGVO)</li>
          <li><strong>Recht auf Löschung</strong> („Recht auf Vergessenwerden“) (Artikel 17 DSGVO)</li>
          <li><strong>Recht auf Einschränkung der Verarbeitung</strong> (Artikel 18 DSGVO)</li>
          <li><strong>Recht auf Benachrichtigung</strong> – Mitteilungspflicht im Zusammenhang mit der Berichtigung oder Löschung personenbezogener Daten oder der Einschränkung der Verarbeitung (Artikel 19 DSGVO)</li>
          <li><strong>Recht auf Datenübertragbarkeit</strong> (Artikel 20 DSGVO)</li>
          <li><strong>Widerspruchsrecht</strong> (Artikel 21 DSGVO)</li>
          <li><strong>Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung</strong> – einschließlich Profiling – beruhenden Entscheidung unterworfen zu werden (Artikel 22 DSGVO)</li>
        </ul>
        <div class="info-callout">
          <mat-icon class="callout-icon">gavel</mat-icon>
          <div>
            Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren, welche in Österreich die Datenschutzbehörde ist, deren Webseite Sie unter
            <a href="https://www.dsb.gv.at/" class="external-link" target="_blank" rel="nofollow noopener">https://www.dsb.gv.at/</a>
            finden.
          </div>
        </div>
      </section>

      <hr class="legal-divider">

      <!-- Section: Auswertung des Besucherverhaltens -->
      <section id="besucherverhalten" class="legal-section">
        <h2>Auswertung des Besucherverhaltens</h2>
        <p>
          In der folgenden Datenschutzerklärung informieren wir Sie darüber, ob und wie wir Daten Ihres Besuchs dieser Website auswerten. Die Auswertung der gesammelten Daten erfolgt in der Regel anonym und wir können von Ihrem Verhalten auf dieser Website nicht auf Ihre Person schließen.
        </p>
        <p>
          Mehr über Möglichkeiten dieser Auswertung der Besuchsdaten zu widersprechen erfahren Sie in den entsprechenden Browsereinstellungen zur Deaktivierung von Tracking-Cookies.
        </p>
      </section>

      <hr class="legal-divider">

      <!-- Section: TLS-Verschlüsselung mit https -->
      <section id="tls-verschluesselung" class="legal-section">
        <h2>TLS-Verschlüsselung mit https</h2>
        <p>
          Wir verwenden https um Daten abhörsicher im Internet zu übertragen (Datenschutz durch Technikgestaltung
          <a href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE&tid=211101306" target="_blank" rel="noopener nofollow" class="external-link">Artikel 25 Absatz 1 DSGVO</a>).
          Durch den Einsatz von TLS (Transport Layer Security), einem Verschlüsselungsprotokoll zur sicheren Datenübertragung im Internet können wir den Schutz vertraulicher Daten sicherstellen. Sie erkennen die Benutzung dieser Absicherung der Datenübertragung am kleinen Schlosssymbol links oben im Browser und der Verwendung des Schemas https (anstatt http) als Teil unserer Internetadresse.
        </p>
      </section>

      <hr class="legal-divider">

      <!-- Section: Impressum -->
      <section id="impressum" class="legal-section impressum-section">
        <div class="section-badge">Anbieterkennzeichnung</div>
        <h2>Impressum & Unternehmensangaben</h2>

        <div class="company-card">
          <div class="company-name">JJ Technology Holding GmbH</div>
          <div class="company-address">
            <span>Peter-Behrens-Platz 10</span>
            <span>4020 Linz, Österreich</span>
          </div>
          <div class="company-details-grid">
            <div class="detail-row">
              <span class="detail-label">Firmenbuchnummer:</span>
              <span class="detail-val">FN 518050 p</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Firmenbuchgericht:</span>
              <span class="detail-val">Landesgericht Linz</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Umsatzsteuer-ID (UID):</span>
              <span class="detail-val">ATU74662304</span>
            </div>
          </div>
        </div>

        <div class="attribution-note">
          <p>
            This product includes GeoLite2 data created by MaxMind, available from
            <a href="https://www.maxmind.com" target="_blank" rel="noopener nofollow" class="external-link">https://www.maxmind.com</a>.
          </p>
          <p class="source-credit">
            Quelle: Erstellt mit dem <a href="https://www.firmenwebseiten.at/datenschutz-generator/" target="_blank" rel="nofollow noopener" class="external-link">Datenschutz Generator von firmenwebseiten.at</a> in Kooperation mit <a href="https://www.hd-dental.net" target="_blank" rel="nofollow noopener" class="external-link">hd-dental.net</a>.
          </p>
        </div>
      </section>

    </div>

    <!-- Bottom Return CTA -->
    <div class="legal-footer-cta">
      <jjames-button variant="primary" size="lg" (clicked)="goBack()">
        ← Zurück zur Registrierung
      </jjames-button>
    </div>

  </div>
</div>
